

export const tratarRetornoErroAxios = (error:any) => {
    let msg = { delay: 5000, tipo: 'danger', texto: 'Erro inesperado! Contacte o administrador informando print desta tela.', url: '/erro' };

    if(!error){
      //error undefined
      msg.texto='Erro inesperado! Contacte o administrador informando print desta tela.';
    } else if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      let tx = !error.response.data ? msg.texto : typeof error.response.data === "string" ? error.response.data : error.response.data.msgs && Array.isArray(error.response.data.msgs) ? error.response.data.msgs[0] : JSON.stringify(error.response.data);
      msg.texto= `${error.response.status} - ${tx}`
    } else if (error.request) {
      // http.ClientRequest in node.js
      msg.texto= `${error.code} - ${!error.message ? msg.texto : typeof error.message === "string" ? error.message : JSON.stringify(error.message)} ao chamar ${error.config.url}!`
    } else {
      // Something happened in setting up the request that triggered an Error
      msg.texto= `Erro - ${JSON.stringify(error)}`
    }
    return msg;
}